import React, { ReactElement } from 'react'

import { RectangleSkeleton, BodyTextLoader, FadeIn, HeadingLoader } from '@pb/components'

import { LoaderProps } from '../../../../types'
import styles from '../../MyStyleboards.scss'

const Loader: React.FC<LoaderProps> = ({ amountOfItems = 6 }) => {
  const loaderItem = (i): ReactElement => (
    <div className={styles.loaderItem} key={`${i}-mystyleboard-loader`}>
      <RectangleSkeleton height="200px" width="300px" />
      <BodyTextLoader rowsNumber={2} />
    </div>
  )

  return (
    <FadeIn>
      <div className={styles.loaderContainer}>
        <HeadingLoader />
        {[...Array(amountOfItems)].map((item, index) => loaderItem(index))}
      </div>
    </FadeIn>
  )
}

export default Loader
